export interface IStudent {
  studentSurname: string;
  studentFirstName: string;
  date: string;
  month: string;
  year: string;
  currentYearGroup: string;
  childPronouns: string;
  other1?: string;
  other2?: string;
  other3?: string;
}

export const studentDefault: IStudent = {
  studentSurname: "",
  studentFirstName: "",
  date: "",
  month: "",
  year: "",
  currentYearGroup: "",
  childPronouns: "",
  other1: "",
  other2: "",
  other3: "",
};

export interface IParent {
  title: string | null;
  firstName: string;
  surname: string;
  email: string;
  email2: string;
  mobileNumber: string;
  mobileNumber2: string;
}

export interface ITermsCondition {
  title: string;
  details: string;
  extDetails: string | null;
}

export const parentDefault = {
  title: "",
  firstName: "",
  surname: "",
  email: "",
  email2: "",
  mobileNumber: "",
  mobileNumber2: "",
};

export interface ISchool {
  id: string;
  label: string;
  icon: string;
  quote: string;
  noticePeriodRequired: string;
  sector: string;
  signUpMethod: string;
  schoolSignUp: boolean;
  showDuration: boolean;
  fees: string;
  feesText: string;
}

export const schoolDefault: ISchool = {
  id: "",
  label: "",
  icon: "",
  quote: "",
  noticePeriodRequired: "",
  sector: "",
  signUpMethod: "",
  schoolSignUp: false,
  showDuration: false,
  fees: "",
  feesText: "",
};

export interface IAddress {
  Address1: string;
  Address2: string;
  Town: string;
  Country: string;
  medicalSenNotes: string;
  applicationNotes: string;
  PostCode: string;
  TermsAndCondition: boolean;
  Consent: boolean;
}

export const addressDefault: IAddress = {
  Address1: "",
  Address2: "",
  Town: "",
  Country: "",
  medicalSenNotes: "",
  applicationNotes: "",
  PostCode: "",
  TermsAndCondition: false,
  Consent: true,
};

export const dateOfBirth = () => {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 15 }, (_, index) => currentYear - index);

  const months = Array.from({ length: 12 }, (_, index) => {
    const date = new Date();
    date.setMonth(index);
    return date.toLocaleString("en-US", { month: "long" });
  });

  const dates = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
    22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
  ];

  return {
    dates,
    months,
    years,
  };
};

export interface IActiveStep {
  parentDetails: boolean;
  studentDetails: boolean;
  addressDetails: boolean;
}

export const activeStepDefault: IActiveStep = {
  parentDetails: false,
  studentDetails: false,
  addressDetails: false,
};

export const getId: Sections = {
  parentDetails: "parent-details",
  studentDetails: "student-details",
  addressDetails: "address-details",
  schoolDetails: "school-content",
  parentContent: "parent-content",
  studentContent: "student-content",
};

interface Sections {
  [key: string]: string;
}
